<template>
  <!-- ヘッダー -->
  <MFITTHeader headerTitle="決済方法選択" />

  <div class="form">
    <!-- 座席種類 -->
    <MFITTBookingSelectPaymentMethod />
  </div>

  <!-- 次ページへのアクションボタン -->
  <div class="foot-button-block">
    <ItemButton
      actionType="btn-primary"
      label="次へ"
      @clicked="goToBookingConfirmation"
    />
    <ItemButton
      actionType="btn-cancel"
      label="戻る"
      @clicked="backToPreviousPage"
    />
  </div>
</template>

<script>
import { computed, ref, watchEffect } from "vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateMfittSelectPaymentMethod",

  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    // 確認画面へ
    const goToBookingConfirmation = () => {
      if (route.query.payment_limited_express_ticket_id) {
        router.push({
          name: "MfittMyTicketPurchase",
          params: { id: route.params.id },
          query: {
            payment_limited_express_ticket_id:
              route.query.payment_limited_express_ticket_id,
          },
        });
      } else {
        router.push({
          name: "MfittBookingConfirmation",
          params: { id: route.params.id },
          query: {
            coupon_id: route.query.coupon_id,
            changing_limited_express_ticket_id:
              route.query.changing_limited_express_ticket_id,
          },
        });
      }
    };

    const backToPreviousPage = () => {
      router.go(-1);
    };

    return {
      goToBookingConfirmation,
      backToPreviousPage,
    };
  },
};
</script>

<style socped>
.foot-button-block {
  position: fixed;
  z-index: 99;
  left: 0;
  width: 90%;
  bottom: 0;
  background-color: #ffffff;
  padding: 15px 15px 20px 15px;
}
.form {
  padding-bottom: 155px;
}
</style>
